import { render, staticRenderFns } from "./UploadSelect.vue?vue&type=template&id=0cb9f82a&scoped=true"
import script from "./UploadSelect.vue?vue&type=script&lang=js"
export * from "./UploadSelect.vue?vue&type=script&lang=js"
import style0 from "./UploadSelect.vue?vue&type=style&index=0&id=0cb9f82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb9f82a",
  null
  
)

export default component.exports